module.exports = __webpack_public_path__ + "static/media/header.9a590576.jpeg";